import React from 'react'
import FooterWidgetComponent from '../widgets/FooterWidget/FooterWidgetComponent'
import BlogBannerComponent from './widget/BlogBanner/BlogBannerComponent'
import FeatureSlidesComponent from './widget/SectionA/FeatureSlidesComponent'
import LatestBlogComponent from './widget/SectionA/LatestBlogComponent'
import PopularBlogComponent from './widget/SectionA/PopularBlogComponent'

function Blog() {
  return (
    <div>
        <BlogBannerComponent/>
        {/* <FeatureSlidesComponent/> */}
        <LatestBlogComponent/>
        {/* <PopularBlogComponent/> */}
        <FooterWidgetComponent/>
    </div>
  )
}

export default Blog